import React, {useEffect, useState} from 'react';
import Box from '../Common/Box';
import shadowClient from '../lib/clients/shadow/shadowClient';
import LoadingView from '../Common/LoadingView';
import Logger from '../lib/Logger';
import {observer} from 'mobx-react';
import scConfig from '../config';
import {getRandomUsername} from '../../data/usernames';
import uiStore from '../lib/stores/uiStore';
import {ErrorCode} from "../lib/clients/shadow/ErrorCode";
import {notifier} from "../lib/Notifier";
import MobileMain from "./Mobile/MobileMain";
import DesktopMain from "./Desktop/DesktopMain";

const logger = new Logger("ShadowChat");

//@todo is dependent on ThreeScreen to run for the animation loop. fix this?
function Main() {

    // const [banned, setBanned] = useState(false);

    const [is404, setIs404] = useState(false);
    const [unknownRoomId, setUnknownRoomId] = useState("");
    const [unknownInvite, setUnknownInvite] = useState("");

    async function connect() {

        const token = shadowClient.getQueryToken();
        let loginToken = token || localStorage.getItem("shadowLoginToken");

        if (!loginToken) {
            const user = await shadowClient.registerAnonymously(getRandomUsername());
            loginToken = user.login_token;
        }

        let rooms;

        if (!shadowClient.connected) {
            ({rooms} = await shadowClient.connect(loginToken));
        } else {
            rooms = shadowClient.roomStore.rooms.filter(room => room.type === 2);
        }

        const clientUser = shadowClient.getClientUser();
        clientUser.login_token = loginToken;


        if (shadowClient.getJoinedRoomId() === null) {
            logger.trace("Connected. %s anonymous rooms available", rooms.length);

            let roomId;
            let invite;

            const inviteRegex = /^\/invites\/(\S+)?$/;
            const inviteMatch = window.location.pathname.match(inviteRegex);

            const roomsRegex = /^(?:\/(?:rooms(?:\/(\d+)?\/?)?)?)?$/;
            const roomsMatch = window.location.pathname.match(roomsRegex);

            if (inviteMatch) {
                invite = inviteMatch[1];
            } else if (roomsMatch) {
                if (roomsMatch[1]) {
                    roomId = roomsMatch[1];
                } else {
                    if (clientUser.room_id) {
                        roomId = clientUser.room_id;
                    } else {
                        logger.trace("Creating new room",);
                        const room = await shadowClient.createRoom();
                        logger.trace("Created new room. Room: %s (%s)", room.name, room.id);
                        roomId = room.id;
                    }

                }
            } else {
                setIs404(true);
                return;
            }

            try {

                if (invite) {
                    await shadowClient.joinRoomWithInvite(invite);
                } else {
                    await shadowClient.joinRoomWithId(roomId);
                }

            } catch (e: any) {
                await shadowClient.disconnect();

                if (e.errorCode === ErrorCode.USER_BANNED) {
                    // setBanned(true);
                    logger.error("User is banned in room %s", roomId)
                } else if (e.httpCode === 404) {
                    setIs404(true);
                    setUnknownRoomId(roomId);
                    return;
                } else {
                    throw e;
                }
            }


        } else if (!rooms?.[0]) {
            const errorMessage = "Connected, but no anonymous rooms were available";
            throw new Error(errorMessage);
        }

        if (clientUser.login_token) {
            localStorage.setItem("shadowLoginToken", clientUser.login_token);
        }

    }

    useEffect(() => {

        connect().catch(e => {
            logger.error("%o", e);
            let errorMessage;
            const token = shadowClient.getQueryToken();

            if (token && e.errorCode === ErrorCode.INVALID_TOKEN) {
                errorMessage = "The query token seems to be invalid. Try a different one or load the page " +
                        "without one to create a new account";
                if (uiStore.isMobile) {
                    window.history.replaceState({}, undefined, window.location.pathname);
                }
            } else {
                errorMessage = "An error occurred while connecting. Please try again later. Error: " + e.message;
            }

            logger.error("Error while connecting. Error %s", e?.stack || e?.message);
            notifier.error(errorMessage);

            const loginToken = localStorage.getItem("shadowLoginToken");

            if (loginToken) {
                localStorage.removeItem("shadowLoginToken");
                window.location.reload();
            }

        }).finally(() => {
            setLoading(false);
        })

    }, []);

    const [loading, setLoading] = useState(true);

    if (loading) {
        return <LoadingView dark={true} logoText={scConfig.appName}/>
    }

    if (is404) {
        let message;

        if (unknownRoomId) {
            message = `Unknown room with id ${unknownRoomId} :x`
        } else if (unknownInvite) {
            message = `Unknown invite ${unknownInvite} :x`
        } else {
            message = `Think yer lost :s. ${window.location.pathname} doesn't exist `
        }

        return <Box expand column center>
            <Box sx={{fontSize: "24px", fontWeight: "bold"}}>404</Box>
            <Box>
                {message}
            </Box>
        </Box>
    }


    if (uiStore.isMobile) {
        return <MobileMain/>
    }

    return <DesktopMain/>
}

export default observer(Main);
